// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    domain: 'staging',
    disableLogRocket: true,
    production: false,
    apiUrl: 'https://api.staging.zeds.openziti.org/api',
    authconfig: {
        clientID: 'VyQG6EJImKnxGk6OaI5K9beN8TvveZOz',
        domain: 'zeds-sandbox.us.auth0.com',
    },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
